import ContainerSimple from "../../../Components/ContainerSimple";
import InputAdmin from "../../../Components/InputFields/InputAdmin";
import Custom from "../../../Components/Buttons/Custom";
import MultipleSelectAdmin from "../../../Components/InputFields/MultipleSelectAdmin";
import BirthDatePicker from "../../../Components/DatePicker/BirthDatePicker";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";

export default function EditCouponContainer({ onClose }) {
  const [categories, setCategories] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [couponData, setCouponData] = useState(null);
  const { couponId } = useParams();

  const [editChallengeId, setEditChallengeId] = useState(null);
  const [editCategory, setEditCategory] = useState(null);

  useEffect(() => {
    console.log("Edit Challenge ID:", editChallengeId);
    console.log("Edit Category:", editCategory);
  });

  const onRowClick = (challengeId) => {
    if (selectedChallenge === "انتخاب یک چالش") {
      setEditCategory(null);
      setEditChallengeId(challengeId);
    } else if (selectedChallenge === "انتخاب یک دسته") {
      setEditChallengeId(null);
      setEditCategory(challengeId);
    } else {
      setEditCategory(null);
      setEditChallengeId(null);
    }
  };

  const fetchChallengesData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      setChallenges(data);
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  const fetchCategoriesData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/categories/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/categories/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      setCategories(data.categories);
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };

  const fetchCouponData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/coupons/${couponId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/coupons/${couponId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      setCouponData(data);
      if (data?.is_for_all_challenges) {
        setSelectedChallenge("انتخاب همه");
      } else if (data?.challenge_category) {
        setSelectedChallenge("انتخاب یک دسته");
        setEditCategory(data.challenge_category);
      } else {
        setSelectedChallenge("انتخاب یک چالش");
        setEditChallengeId(data.challenge);
      }
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  useEffect(() => {
    fetchCategoriesData();
    fetchChallengesData();
    fetchCouponData();
  }, []);

  const [selectedChallenge, setSelectedChallenge] = useState("");

  useEffect(() => {
    if (selectedChallenge === "انتخاب یک دسته") {
      setEditChallengeId(null);
    } else if (selectedChallenge === "انتخاب یک چالش") {
      setEditCategory(null);
    } else {
      setEditCategory(null);
      setEditChallengeId(null);
    }
  }, [selectedChallenge]);
  const handleEdit = async () => {
    if (
      !couponData.name ||
      !couponData.discount_percent ||
      !couponData.limits ||
      !couponData.expired_at
    ) {
      return;
    }
    if (selectedChallenge === "انتخاب یک دسته" && !editCategory) {
      return;
    }
    if (selectedChallenge === "انتخاب یک چالش" && !editChallengeId) {
      return;
    }
    const name = couponData.name;
    const discount = Number(couponData.discount_percent);
    const limit = Number(couponData.limits);
    const expiredAt = couponData.expired_at;

    const selectedTarget =
      selectedChallenge === "انتخاب یک چالش"
        ? editChallengeId
        : selectedChallenge === "انتخاب یک دسته"
          ? editCategory
          : null;
    const jsonData = {
      name: name,
      discount_percent: discount,
      limits: limit,
      expired_at: expiredAt,
    };
    if (selectedChallenge === "انتخاب یک چالش") {
      jsonData["challenge"] = selectedTarget;
    } else if (selectedChallenge === "انتخاب یک دسته") {
      jsonData["challenge_category"] = selectedTarget;
    } else if (selectedChallenge === "انتخاب همه") {
      jsonData["is_for_all_challenges"] = true;
    }
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/coupons/${couponId}/edit/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify(jsonData),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/coupons/${couponId}/edit/`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify(jsonData),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      window.location.href = `/coupons`;
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };

  const handleExpire = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/coupons/${couponId}/expire/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/coupons/${couponId}/expire/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      window.location.href = `/coupons`;
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };

  return (
    <ContainerSimple>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="کد تخفیف"
          id="type"
          name="type"
          type="text"
          value={couponData?.name}
          onChange={(e) =>
            setCouponData((pre) => ({ ...pre, name: e.target.value }))
          }
        />
        <InputAdmin
          label="درصد تخفیف"
          id="type"
          name="type"
          type="number"
          value={couponData?.discount_percent}
          onChange={(e) =>
            setCouponData((pre) => ({
              ...pre,
              discount_percent: e.target.value,
            }))
          }
        />
        <BirthDatePicker
          label="تاریخ انقضا"
          value={couponData?.expired_at || ""}
          onChange={(value) =>
            setCouponData((pre) => ({ ...pre, expired_at: value }))
          }
          isReadOnly={false}
          variant="admin"
          minYearsAgo={10}
          maxYearsFromNow={20}
        />
      </div>
      <div className="w-full flex gap-12">
        {/* <InputAdmin
          label="مهلت روزهای استفاده پس از خرید"
          id="type"
          name="type"
          type="number"
        /> */}
        <InputAdmin
          label="محدودیت تعداد استفاده"
          id="type"
          name="type"
          type="number"
          // isLtr={true}
          value={couponData?.limits}
          onChange={(e) => {
            if (!e.target.value) {
              setCouponData((pre) => ({ ...pre, limits: e.target.value }));
            } else {
              setCouponData((pre) => ({
                ...pre,
                limits: Number(e.target.value),
              }));
            }
          }}
        />
        <InputAdmin
          label="کاربر"
          id="coupon-user"
          name="coupon-user"
          type="text"
          value={couponData?.user ?? "برای همه"}
          readOnly={true}
          inputClassName="cursor-default"
        />
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="مناسب برای چالش"
          id="type"
          name="type"
          type="select"
          selectOptions={["انتخاب یک چالش", "انتخاب یک دسته", "انتخاب همه"]}
          selectPlaceHolder="انتخاب کنید"
          value={selectedChallenge}
          onChange={(e) => setSelectedChallenge(e.target.value)}
        />
        <div className="w-full"></div>
        <div className="w-full"></div>
      </div>
      {selectedChallenge === "انتخاب یک چالش" && (
        <MultipleSelectAdmin
          header="انتخاب یک چالش"
          search={false}
          footer="چالش انتخاب شده"
          footerValue={
            challenges?.find((chal) => chal.id === editChallengeId)?.name || ""
          }
          tableColumns={[
            { key: "code", label: "کد چالش" },
            { key: "category", label: "دسته چالش" },
            { key: "name", label: "نام چالش" },
          ]}
          tableData={challenges?.map((challenge) => ({
            id: challenge.id,
            code: challenge.id,
            category: challenge.category,
            name: challenge.name,
          }))}
          selectedIndex={challenges?.findIndex(
            (chal) => chal.id === editChallengeId,
          )}
          onRowClick={onRowClick}
        />
      )}
      {selectedChallenge === "انتخاب یک دسته" && (
        <MultipleSelectAdmin
          header="انتخاب یک دسته"
          search={false}
          footer="دسته انتخاب شده"
          footerValue={editCategory}
          tableColumns={[{ key: "category", label: "دسته چالش" }]}
          tableData={categories?.map((category) => ({
            id: category,
            category: category,
          }))}
          selectedIndex={categories?.findIndex((cat) => cat === editCategory)}
          onRowClick={onRowClick}
        />
      )}
      <div className="w-full flex gap-2.5 mt-6">
        <Custom
          text="بستن آنی کد تخفیف"
          svg_name="xMark"
          svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 w-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark bg-transparent"
          onClick={handleExpire}
        />
        <Custom
          text="تأیید ویرایش"
          svg_name="checkMark"
          svgClassName="stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 w-full text-zi-text-dark bg-zi-gradient-button-blue"
          textShadow={true}
          svgShadow={true}
          onClick={handleEdit}
        />
      </div>
    </ContainerSimple>
  );
}
